module.exports = __webpack_public_path__ + "img/expired.643553b8.jpg";